import { tv } from '../_lib/utils';
import { Anchor } from '../Anchor';
import { Avatar, type AvatarProps } from '../Avatar';
import { Text } from '../Text';
import { ReactNode } from 'react';

const styles = tv({
	slots: {
		base: 'inline-flex items-center gap-4',
		avatar: '',
		content: '',
		name: '',
		meta: 'text-text-secondary',
	},
	variants: {
		alignment: {
			left: {},
			center: {
				base: 'flex-col text-center',
			},
			right: {
				base: 'flex-row-reverse text-right',
			},
		},
		avatarMobile: {
			true: {
				content: 'grid gap-1',
			},
			false: {
				avatar: 'max-md:hidden',
				content: 'md:grid md:gap-1',
				meta: 'max-md:before:content-[","] max-md:before:mr-[0.25em]',
			},
		},
		hasLink: {
			true: {
				base: 'relative',
				name: 'link before:content-[""] before:top-0 before:left-0 before:right-0 before:bottom-0 before:absolute before:z-10',
			},
		},
	},
});

export type AuthorProps = AvatarProps & {
	_key?: string;
	alignment?: 'left' | 'center' | 'right';
	avatarMobile?: boolean;
	className?: string;
	href?: string;
	name?: string;
	meta?: ReactNode;
};

export function Author(props: AuthorProps) {
	const alignment = props.alignment ?? 'left';
	const avatarMobile = props.avatarMobile ?? true;
	const hasLink = !!props.href;
	const { base, avatar, content, name, meta } = styles({ alignment, avatarMobile, hasLink });
	const size = props.size ?? 'lg';

	return (
		<div className={base({ className: props.className })} data-component='Author'>
			<Avatar className={avatar()} image={props.image} size={size} />
			<div className={content()}>
				{props.href ? (
					<div className={`flex`}>
						<Anchor className={name()} href={props.href}>
							<Text as='span' styleType='heading-5xs'>
								{props.name}
							</Text>
						</Anchor>
					</div>
				) : (
					<Text as='span' className={name()} styleType='heading-5xs'>
						{props.name}
					</Text>
				)}
				{props.meta && (
					<Text as='span' className={meta()} styleType='heading-5xs'>
						{props.meta}
					</Text>
				)}
			</div>
		</div>
	);
}
